/* eslint-disable react/no-unused-state */
import * as partnerPlanFormSchema from 'schemas/forms/PartnerPlanForm'
import Heading from 'components/Heading'
import Modal from 'components/Modal'
import React, { PropTypes, Component } from 'react'
import TextInput from 'components/Form/components/TextInput'
import styles from './PartnerPlanDisplayForm.scss'
import constants from 'constants'

import {
  formUpdate,
  formInit,
  formSubmit,
  formReset,
} from 'actions/forms'

class PartnerPlanNoteDisplayForm extends Component {
  static propTypes = {
    data: PropTypes.object,
    description: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
    forms: PropTypes.object.isRequired,
    hide: PropTypes.func.isRequired,
    id: PropTypes.string,
    modals: PropTypes.object.isRequired,
    noteHeader: PropTypes.string,
    partnerPlan: PropTypes.object,
    show: PropTypes.bool,
    title: PropTypes.string,
  }
  static defaultProps = {
    data: {},
    show: false,
    description: '',
    id: `${constants.PARTNERPLAN.FORMS.NOTES}`,
    title: '',
    partnerPlan: null,
    noteHeader: '',
  }

  componentWillMount() {
    const { formFields } = partnerPlanFormSchema

    const formData = {
      formFields,
      data: this.props.data || null,
    }

    this.props.dispatch(formInit(this.props.id, formData))
  }

  componentWillReceiveProps(nextProps) {
    const { partnerPlan } = this.props.partnerPlan

    const modalCreated = this.props.modals.partnerPlanNoteForm
    const modalChanged = modalCreated && nextProps.modals.partnerPlanNoteForm.show !== this.props.modals.partnerPlanNoteForm.show
    const modalNotVisible = modalCreated && !nextProps.modals.partnerPlanNoteForm.show
    const modalVisible = modalCreated && nextProps.modals.partnerPlanNoteForm.show
    // const dataChanged = nextProps.data !== this.props.data

    if (modalChanged && modalNotVisible) {
      this.props.dispatch(formReset(this.props.id))
    }

    if (modalChanged && modalVisible) {
      // preload data from BED if needed
      this._handleChange('planStatus', partnerPlan.planStatus || '')
      this._handleChange('counsellorInterimAssessment', partnerPlan.interimCounsellor || '')
      this._handleChange('counsellorFinalAssessment', partnerPlan.finalCounsellorAssessment || '')
      this._handleChange('finalAgreedInterimAssessment', partnerPlan.finalAgreedInterimRating || '')
      this._handleChange('finalAgreedInterimAssessmentComments', partnerPlan.finalAgreedInterimComments || '')
      this._handleChange('finalAgreedFinalAssessment', partnerPlan.finalAgreedFinalRating || '')
      this._handleChange('finalAgreedFinalAssessmentComments', partnerPlan.finalAgreedFinalComments || '')
      this._handleChange('interimCounselleeComments', partnerPlan.interimCounselleeComments || '')
      this._handleChange('interimCounsellorComments', partnerPlan.interimCounsellorComments || '')
      this._handleChange('finalCounselleeComments', partnerPlan.finalCounselleeComments || '')
      this._handleChange('finalCounsellorComments', partnerPlan.finalCounsellorComments || '')
    }
  }

  _schema = () => {
    const obj = {}
    partnerPlanFormSchema.formFields.forEach((field) => {
      obj[field.name] = field
    })
    return obj
  }

  _hide = () => {
    this.props.hide(this.props.id)
    this.props.dispatch(formReset(this.props.id))
  }

  _handleState = (stateValue) => {
    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleValidation = (name) => {
    const stateValue = {
      field: name,
      data: {
        focus: false,
      },
    }

    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleFocus = (name) => {
    // Create state value obj
    const stateValue = {
      field: name,
      data: {
        focus: true,
      },
    }

    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  // Handle Changes on form elements
  _handleChange = (name, value) => {
    /*
      Create state value obj
      Reset error handling (Stops error check on focus changes)
    */
    const stateValue = {
      field: name,
      data: {
        value,
        error: '',
        valid: true,
      },
    }
    // Pass state value and handle state
    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  render() {
    const {
      title,
      dispatch,
      modals,
      description,
      noteHeader,
    } = this.props
    const schema = this._schema()
    const form = this.props.forms[this.props.id]
    const disable = (form && form._isPosting)
    const forceClose = (form && form._hasCompleted)
    const formHasFetched = this.props.hasFetched

    return (
      <Modal
        className={styles.bg}
        disable={disable}
        dispatch={dispatch}
        forceClose={forceClose}
        id={constants.PARTNERPLAN.FORMS.NOTES}
        modals={modals}
        onClose={this._hide}
      >
        <div className={styles.base}>
          <Heading className={styles.title} size="large">
            {title}
          </Heading>
          <p className={styles.content}>{description}</p>
          {form &&
          <form
            className={styles.form}
            id={this.props.id}
            noValidate="novalidate"
            onSubmit={this._handleSubmit}
          >
            <div className={styles.sectionHeader} />
            <fieldset>
              <ul>
                {noteHeader === constants.PARTNERPLAN.NOTES_HEADER.INTERIM_PARTNER &&
                  <li>
                    <TextInput
                      {...schema.interimCounselleeComments}
                      disabled
                      multiline
                      error={form.interimCounselleeComments.error}
                      focus={form.interimCounselleeComments.focus}
                      handleChange={this._handleChange}
                      onBlur={this._handleValidation}
                      onFocus={this._handleFocus}
                      text={form.interimCounselleeComments.value}
                      valid={form.interimCounselleeComments.valid}
                    />
                  </li>}
                {noteHeader === constants.PARTNERPLAN.NOTES_HEADER.INTERIM_COUNSELLOR &&
                  <li>
                    <TextInput
                      disabled
                      multiline
                      {...schema.counsellorInterimAssessment}
                      error={form.counsellorInterimAssessment.error}
                      focus={form.counsellorInterimAssessment.focus}
                      handleChange={this._handleChange}
                      onBlur={this._handleValidation}
                      onFocus={this._handleFocus}
                      text={form.counsellorInterimAssessment.value}
                      valid={form.counsellorInterimAssessment.valid}
                    />
                    <TextInput
                      disabled
                      multiline
                      {...schema.interimCounsellorComments}
                      error={form.interimCounsellorComments.error}
                      focus={form.interimCounsellorComments.focus}
                      handleChange={this._handleChange}
                      onBlur={this._handleValidation}
                      onFocus={this._handleFocus}
                      text={form.interimCounsellorComments.value}
                      valid={form.interimCounsellorComments.valid}
                    />
                    <TextInput
                      disabled
                      multiline
                      {...schema.finalAgreedInterimAssessment}
                      error={form.finalAgreedInterimAssessment.error}
                      focus={form.finalAgreedInterimAssessment.focus}
                      handleChange={this._handleChange}
                      onBlur={this._handleValidation}
                      onFocus={this._handleFocus}
                      text={form.finalAgreedInterimAssessment.value}
                      valid={form.finalAgreedInterimAssessment.valid}
                    />
                    <TextInput
                      disabled
                      multiline
                      {...schema.finalAgreedInterimAssessmentComments}
                      error={form.finalAgreedInterimAssessmentComments.error}
                      focus={form.finalAgreedInterimAssessmentComments.focus}
                      handleChange={this._handleChange}
                      onBlur={this._handleValidation}
                      onFocus={this._handleFocus}
                      text={form.finalAgreedInterimAssessmentComments.value}
                      valid={form.finalAgreedInterimAssessmentComments.valid}
                    />                                        
                  </li>}
                {noteHeader === constants.PARTNERPLAN.NOTES_HEADER.FINAL_PARTNER &&
                  <li>
                    <TextInput
                      disabled
                      multiline
                      {...schema.finalCounselleeComments}
                      error={form.finalCounselleeComments.error}
                      focus={form.finalCounselleeComments.focus}
                      handleChange={this._handleChange}
                      onBlur={this._handleValidation}
                      onFocus={this._handleFocus}
                      text={form.finalCounselleeComments.value}
                      valid={form.finalCounselleeComments.valid}
                    />
                  </li>}
                {noteHeader === constants.PARTNERPLAN.NOTES_HEADER.FINAL_COUNSELLOR &&
                  <li>
                    <TextInput
                      disabled
                      multiline
                      {...schema.counsellorFinalAssessment}
                      error={form.counsellorFinalAssessment.error}
                      focus={form.counsellorFinalAssessment.focus}
                      handleChange={this._handleChange}
                      onBlur={this._handleValidation}
                      onFocus={this._handleFocus}
                      text={form.counsellorFinalAssessment.value}
                      valid={form.counsellorFinalAssessment.valid}
                    />
                    <TextInput
                      disabled
                      multiline
                      {...schema.finalCounsellorComments}
                      error={form.finalCounsellorComments.error}
                      focus={form.finalCounsellorComments.focus}
                      handleChange={this._handleChange}
                      onBlur={this._handleValidation}
                      onFocus={this._handleFocus}
                      text={form.finalCounsellorComments.value}
                      valid={form.finalCounsellorComments.valid}
                    />
                    <TextInput
                      disabled
                      multiline
                      {...schema.finalAgreedFinalAssessment}
                      error={form.finalAgreedFinalAssessment.error}
                      focus={form.finalAgreedFinalAssessment.focus}
                      handleChange={this._handleChange}
                      onBlur={this._handleValidation}
                      onFocus={this._handleFocus}
                      text={form.finalAgreedFinalAssessment.value}
                      valid={form.finalAgreedFinalAssessment.valid}
                    />
                    <TextInput
                      disabled
                      multiline
                      {...schema.finalAgreedFinalAssessmentComments}
                      error={form.finalAgreedFinalAssessmentComments.error}
                      focus={form.finalAgreedFinalAssessmentComments.focus}
                      handleChange={this._handleChange}
                      onBlur={this._handleValidation}
                      onFocus={this._handleFocus}
                      text={form.finalAgreedFinalAssessmentComments.value}
                      valid={form.finalAgreedFinalAssessmentComments.valid}
                    /></li>
                  }
              </ul>
            </fieldset>
          </form>
        }
        </div>
      </Modal>
    )
  }
}

export default PartnerPlanNoteDisplayForm



// WEBPACK FOOTER //
// ./src/views/PartnerPlans/PartnerPlanNoteDisplayForm.js